<template>
  <v-container fluid class="pa-0">
    <v-layout column>
      <v-layout row justify="space-between">
        <v-col><v-btn class="px-2" @click="showReferralEdit = true">Amend Details</v-btn></v-col>
        <v-col v-if="UserHasRole('Platform') || UserHasRole('Call Centre')"
          ><v-btn class="px-2" @click="showRegistration = true">Register SME</v-btn></v-col
        >
        <v-col v-if="UserHasRole('Platform') || UserHasRole('Call Centre')"
          ><v-btn class="px-2" @click="rejectReferral">Reject</v-btn></v-col
        >
        <v-col v-if="referral.open === false"><v-btn class="px-2" @click="reopenReferral">Re-open</v-btn></v-col>
      </v-layout>
      <v-divider></v-divider>
      <v-layout v-if="UserHasRole('Platform') || UserHasRole('Call Centre')">
        <v-switch label="To be called" v-model="toBeCalled"></v-switch>
      </v-layout>
      <v-divider v-if="UserHasRole('Platform') || UserHasRole('Call Centre')"></v-divider>
      <v-list dense class="transparent">
        <v-subheader>Business</v-subheader>
        <v-list-item>
          <v-list-item-title>Type</v-list-item-title>
          <v-list-item-subtitle class="align-end">{{ startCase(referral.legal_status) }}</v-list-item-subtitle>
        </v-list-item>
        <v-list-item v-if="referral.customer.turnover">
          <v-list-item-title>Turnover</v-list-item-title>
          <v-list-item-subtitle class="align-end">
            {{ customerTurnover }}
          </v-list-item-subtitle>
        </v-list-item>
        <v-list-item v-if="referral.customer.profitability">
          <v-list-item-title>Profitability</v-list-item-title>
          <v-list-item-subtitle class="align-end">{{ referral.customer.profitability }}</v-list-item-subtitle>
        </v-list-item>
        <v-list-item v-if="referral.customer.purpose_of_funding">
          <v-list-item-title>Purpose of Funding</v-list-item-title>
          <v-list-item-subtitle class="align-end">{{ referral.customer.purpose_of_funding }}</v-list-item-subtitle>
        </v-list-item>
        <v-list-item v-if="referral.customer.trading_history">
          <v-list-item-title>Trading History</v-list-item-title>
          <v-list-item-subtitle class="align-end">{{ referral.customer.trading_history }}</v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>Months Trading</v-list-item-title>
          <v-list-item-subtitle class="align-end">{{ referral.months_of_revenue }}</v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Address</v-list-item-title>
            <v-list-item-subtitle>
              <pretty-address :address="referral.address"></pretty-address>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="referral.customer.credit_score" class="list__tile__xl">
          <v-list-item-title>Credit Score</v-list-item-title>
          <v-list-item-subtitle>
            <credit-gauge size="150" :score="referral.customer.credit_score" />
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list dense class="transparent">
        <v-subheader>Contact</v-subheader>
        <v-list-item>
          <v-list-item-title>Name</v-list-item-title>
          <v-list-item-subtitle class="align-end"
            >{{ referral.first_name }} {{ referral.last_name }}</v-list-item-subtitle
          >
        </v-list-item>
        <v-list-item>
          <v-list-item-title>Phone</v-list-item-title>
          <v-list-item-subtitle class="align-end font-weight-black subtitle-1">{{
            referral.phone
          }}</v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>Email</v-list-item-title>
          <v-list-item-subtitle class="align-end"
            ><a :href="`mailto:${referral.email}`">{{ referral.email }}</a></v-list-item-subtitle
          >
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list dense class="transparent">
        <v-subheader>Enquiry</v-subheader>
        <v-list-item>
          <v-list-item-title>Requested amount</v-list-item-title>
          <v-list-item-subtitle class="align-end">{{
            referral.requested_amount | currency('£', ',', 2)
          }}</v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>Requested on</v-list-item-title>
          <v-list-item-subtitle class="align-end">{{ referral.requested_on }}</v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>Required by</v-list-item-title>
          <v-list-item-subtitle class="align-end">{{ referral.required_by }}</v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>Type of Finance</v-list-item-title>
          <v-list-item-subtitle class="align-end">{{
            startCase(referral.finance_type_requested)
          }}</v-list-item-subtitle>
        </v-list-item>
      </v-list>
      <customer-registration-dialog
        :referralDetails="referral"
        :show.sync="showRegistration"
      ></customer-registration-dialog>
      <referral-edit-dialog :referralDetails="referral" :show.sync="showReferralEdit"></referral-edit-dialog>
    </v-layout>
    <reject-referral-form
      :referral="referral"
      :dialog="rejectDialog"
      @changed="rejectFormChanged"
    ></reject-referral-form>
  </v-container>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import CustomerRegistrationDialog from '../Customers/CustomerRegistration/CustomerRegistrationDialog';
import PrettyAddress from '../Customers/Widgets/PrettyAddress';
import ReferralEditDialog from './Widgets/ReferralEditDialog';
import RejectReferralForm from './Widgets/RejectReferralForm';
import CreditGauge from '@/components/Platform/Customers/Widgets/CreditGauge';
import { formatAsCurrency } from '@/utils/formatters';

export default {
  components: {
    CreditGauge,
    CustomerRegistrationDialog,
    PrettyAddress,
    ReferralEditDialog,
    RejectReferralForm
  },
  name: 'referral-info',
  props: ['referral'],
  data: () => ({
    closeReasons: [
      { value: "Platform - Couldn't find SME finance", reason: "Platform - Couldn't find SME finance" },
      { value: 'Platform - Successful funding', reason: 'Platform - Successful funding' },
      { value: 'Platform - Never made contact', reason: 'Platform - Never made contact' },
      { value: 'Platform - None responsive', reason: 'Platform - None responsive' },
      { value: 'Platform - SME no longer eligible', reason: 'Platform - SME no longer eligible' },
      { value: 'SME - No longer require finance', reason: 'SME - No longer require finance' },
      { value: 'SME - Found/sought finance elsewhere', reason: 'SME - Found/sought finance elsewhere' },
      { value: 'Bank - Unreferred SME', reason: 'Bank - Unreferred SME' },
      { value: 'Platform - Test data', reason: 'Platform - Test data' },
      { value: 'Platform - Duplicate data', reason: 'Platform - Duplicate data' },
      { value: 'Platform – Invalid contact data', reason: 'Platform – Invalid contact data' }
    ],
    closing: false,
    closeReason: null,
    showRegistration: false,
    showReferralEdit: false,
    rejectDialog: false
  }),
  methods: {
    ...mapActions(['updateReferral', 'addNotification']),
    startCase: function(str) {
      str = _.lowerCase(str);
      return _.startCase(str);
    },
    rejectReferral: function() {
      this.rejectDialog = true;
    },
    rejectFormChanged: function(rejectReason) {
      this.rejectDialog = false;
      if (!_.isEmpty(rejectReason) && !_.isNull(rejectReason)) {
        this.updateReferral({
          id: this.referral.id,
          updates: {
            open: false,
            reject_reason: rejectReason
          }
        });
      }
    },
    reopenReferral: function() {
      this.updateReferral({
        id: this.referral.id,
        updates: {
          open: true
        }
      });
    }
  },
  computed: {
    ...mapGetters(['UserHasRole', 'ReferralDocuments']),
    customerTurnover() {
      if (!this.referral.customer.turnover) {
        return null;
      }

      const value = parseFloat(this.referral.customer.turnover);

      if (value) {
        return formatAsCurrency(value);
      }

      return this.referral.customer.turnover;
    },
    toBeCalled: {
      get() {
        return this.referral.to_be_called;
      },
      set(state) {
        this.updateReferral({
          id: this.referral.id,
          updates: {
            to_be_called: state
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.list__flex {
  display: flex !important;

  li:not(:last-child) {
    border-right: 1px solid rgba(0, 0, 0, 0.12);
  }
}

::v-deep .list__tile {
  user-select: unset;
}

.list__tile__xl {
  ::v-deep .list__tile {
    height: auto;
  }
}

.short {
  width: 107.5px;
  min-width: 107.5px;
}

::v-deep .v-list-item__subtitle {
  user-select: text;
}
</style>
